/* eslint-disable import/no-unresolved */
import PropTypes from 'prop-types';
import { Form, FormikProvider, useFormik } from 'formik';
// material
import { LoadingButton } from '@material-ui/lab';
import { Box, Stack, TextField, Autocomplete } from '@material-ui/core';
import { getFilterMasterFileData } from 'src/redux/slices/masterfile';
// utils
import { useDispatch, useSelector } from 'react-redux';

// ----------------------------------------------------------------------

TableSearchFilters.propTypes = {
  handleClose: PropTypes.func
};

export default function TableSearchFilters({ handleClose }) {
  const dispatch = useDispatch();
  const { clientList } = useSelector((state) => state.client);
  const { projectList } = useSelector((state) => state.project);
  const { fileCategoryList } = useSelector((state) => state.filecategory);

  const formik = useFormik({
    initialValues: {
      client: '',
      project: '',
      fileCategory: ''
    },
    // validationSchema: NewBlogSchema,
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      try {
        const formData = {
          category_id: values.fileCategory.id || null,
          client_id: values.client.id || null,
          project_id: values.project.id || null
        };
        dispatch(getFilterMasterFileData(formData));
        resetForm();
        setSubmitting(false);
        handleClose();
      } catch (error) {
        console.error(error);
        setSubmitting(false);
      }
    }
  });

  const { values, handleSubmit, isSubmitting, setFieldValue } = formik;

  return (
    <FormikProvider value={formik}>
      <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
        <Stack direction={{ xs: 'column', sm: 'column' }} spacing={{ xs: 2, sm: 2 }} alignItems="center">
          <Stack direction={{ xs: 'column', sm: 'column' }} spacing={{ xs: 2, sm: 2 }} alignItems="center">
            <Autocomplete
              name="client"
              sx={{ width: '230px !important;', padding: '1px !important;' }}
              value={values.client ? values.client : null}
              onChange={(event, newValue) => {
                setFieldValue('client', newValue);
              }}
              options={clientList}
              getOptionLabel={(option) => (option ? option?.client_name : '')}
              renderInput={(params) => <TextField {...params} label="Client" margin="none" />}
            />
          </Stack>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 2, sm: 2 }}>
            <Autocomplete
              name="project"
              sx={{ width: '230px !important;' }}
              value={values.project ? values.project : null}
              onChange={(event, newValue) => {
                console.log('aaaa', newValue);
                setFieldValue('project', newValue);
              }}
              options={projectList}
              getOptionLabel={(option) => (option ? option?.project_name : '')}
              renderInput={(params) => <TextField {...params} label="Project" margin="none" />}
            />
          </Stack>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 2, sm: 2 }}>
            <Autocomplete
              name="File Type"
              sx={{ width: '230px !important;' }}
              value={values.fileCategory ? values.fileCategory : null}
              onChange={(event, newValue) => {
                setFieldValue('fileCategory', newValue);
              }}
              options={fileCategoryList}
              getOptionLabel={(option) => (option ? option?.category_name : '')}
              renderInput={(params) => <TextField {...params} label="File Type" margin="none" />}
            />
          </Stack>
          <Stack spacing={3}>
            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
              <LoadingButton sx={{ marginRight: '1rem' }} type="button" variant="outlined" onClick={handleClose}>
                Cancel
              </LoadingButton>
              <LoadingButton sx={{ marginRight: '1rem' }} type="submit" variant="contained" loading={isSubmitting}>
                Apply
              </LoadingButton>
            </Box>
          </Stack>
        </Stack>
      </Form>
    </FormikProvider>
  );
}
